import { Injectable } from '@angular/core';
import { ByaHttp } from 'app/services/bya-http';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { Tercero } from '../models/tercero';
import { tap, catchError } from 'rxjs/operators';
import { Departamento } from '../models/departamento';
import { Municipio } from '../models/municipio';
import { AuthService } from '../../../../@bya/auth/services/authentication.service';

@Injectable({
    providedIn: 'root'
})
export class TerceroService extends ByaHttp {

    constructor(
        private http: HttpClient,
		protected dialog: MatDialog,
		private _authService: AuthService) {
		super(dialog, _authService);
    }

    GetDepartamentos(): Observable<Departamento[]> {
        return this.http.get<Departamento[]>(this.baseUrl + 'api/Tercero/Departamentos')
            .pipe(
                tap(_ => this.log('fetched task')),
                catchError(this.handleError<Departamento[]>('OBTENER DEPARTAMENTOS', []))
            );
    }

    GetMunicipios(codigoDpto:string): Observable<Municipio[]> {
        return this.http.get<Municipio[]>(this.baseUrl + 'api/Tercero/Municipios/'+codigoDpto)
            .pipe(
                tap(_ => this.log('fetched task')),
                catchError(this.handleError<Municipio[]>('OBTENER MUNICIPIOS DE UN DEPARTAMENTO', []))
            );
    }

    GetTiposTerceros(): Observable<TipoTercero[]> {
        return this.http.get<TipoTercero[]>(this.baseUrl + 'api/Tercero/Obtener/TiposTerceros')
            .pipe(
                tap(_ => this.log('fetched task')),
                catchError(this.handleError<TipoTercero[]>('OBTENER TIPOS TERCEROS', []))
            );
    }

    GetAll(): Observable<Array<Tercero>> {
        return this.http.get<Array<Tercero>>(this.baseUrl + 'api/Tercero')
            .pipe(
                tap(_ => this.log('fetched task')),
                catchError(this.handleError<Array<Tercero>>('OBTENER TERCEROS', null))
            );
    }
    GetAllPorRangoDeFechas(fechaInicial:Date, fechaFinal:Date): Observable<Array<Tercero>> {
        return this.http.get<Array<Tercero>>(`${this.baseUrl}api/Tercero/Desde/${this.dateToString(fechaInicial)}/Hasta/${this.dateToString(fechaFinal)}`)
            .pipe(
                tap(_ => this.log('fetched task')),
                catchError(this.handleError<Array<Tercero>>('OBTENER TERCEROS', null))
            );
    }

    FindById(terceroId:number): Observable<GetTerceroByIdResponse> {
        return this.http.get<GetTerceroByIdResponse>(this.baseUrl + 'api/Tercero/FindById/'+ terceroId)
            .pipe(
                tap(_ => this.log('fetched task')),
                catchError(this.handleError<GetTerceroByIdResponse>('OBTENER TERCERO POR ID', null))
            );
    }

    VerificarTerceroNoExista(identificacion: string): Observable<GetTerceroByIdentificacionResponse> {
        return this.http.get<GetTerceroByIdentificacionResponse>(this.baseUrl + 'api/Tercero/Validar/QueNoExista/' + identificacion)
            .pipe(
                tap(_ => this.log('fetched task')),
                catchError(this.handleError<GetTerceroByIdentificacionResponse>('OBTENER TERCERO POR ID', null))
            );
    }

    public CalcularDigitoVerificacion(identificacion: string): Observable<string> {
        return this.http.get<string>(this.baseUrl + 'api/Tercero/CalcularDigitoVerificacion/' + identificacion)
            .pipe(
                tap(_ => this.log('fetched task')),
                catchError(this.handleError<string>('CALCULAR DIGITO VERIFICACION', null))
            );
    }

    FindByFiltro(filtroBusqueda:string): Observable<GetTerceroByFiltroResponse> {
        return this.http.get<GetTerceroByFiltroResponse>(this.baseUrl + 'api/Tercero/FindByFiltro/'+ filtroBusqueda)
            .pipe(
                tap(_ => this.log('fetched task')),
                catchError(this.handleError<GetTerceroByFiltroResponse>('OBTENER TERCEROS POR FILTRO DE BUSQUEDA', null))
            );
    }

    CrearTercero(request: CrearTerceroServiceRequest): Observable<CrearTerceroServiceResponse> {
        return this.http.post<CrearTerceroServiceResponse>(this.baseUrl + 'api/Tercero', request)
            .pipe(
                tap(_ => this.log('fetched task')),
                catchError(this.handleError<CrearTerceroServiceResponse>('REGISTRAR TERCERO', null))
            );
    }

    EditarTercero(request: EditarTerceroServiceRequest): Observable<EditarTerceroServiceResponse> {
        return this.http.put<EditarTerceroServiceResponse>(this.baseUrl + 'api/Tercero', request)
            .pipe(
                tap(_ => this.log('fetched task')),
                catchError(this.handleError<EditarTerceroServiceResponse>('ACTUALIZAR TERCERO', null))
            );
    }

    EliminarTercero(identificacion: string): Observable<EliminarTerceroServiceResponse> {
        return this.http.delete<EliminarTerceroServiceResponse>(this.baseUrl + 'api/Tercero/' + identificacion)
            .pipe(
                tap(_ => this.log('fetched task')),
                catchError(this.handleError<EliminarTerceroServiceResponse>('ELIMINAR TERCERO', null))
            );
    }

    public exportarAExcel(): Observable<Blob> {
        return this.http.get(this.baseUrl + 'api/Tercero/Exportar', {responseType: 'blob'})
            .pipe(
                tap(_ => this.log('fetched task')),
                catchError(this.handleError<Blob>('EXPORTAR TERCEROS A EXCEL', null))
            );
    }
    public exportarAExcelPorRangoDeFecha(fechaInicial:Date, fechaFinal:Date): Observable<Blob> {
        return this.http.get(`${this.baseUrl}api/Tercero/Exportar/Desde/${this.dateToString(fechaInicial)}/Hasta/${this.dateToString(fechaFinal)}`, {responseType: 'blob'})
            .pipe(
                tap(_ => this.log('fetched task')),
                catchError(this.handleError<Blob>('EXPORTAR TERCEROS A EXCEL', null))
            );
    }

    public getOrdenesTercero(): Observable<OrdenTercero[]> {
        return this.http.get<OrdenTercero[]>(this.baseUrl + 'api/Tercero/Obtener/OrdenesTerceros')
            .pipe(
                tap(_ => this.log('fetched task')),
                catchError(this.handleError<OrdenTercero[]>('OBTENER ORDENES TERCEROS', []))
            );
    }

    private dateToString(date:Date):string {
        if(!date) return "N.A";
        let dateString:string = date.toLocaleDateString();
        while(dateString.includes("/")){
            dateString = dateString.replace("/","-");
        }
        return dateString;
    }
}

export class GetTerceroByIdentificacionResponse {
    public mensaje: string;
    public error: boolean;
    public tercero: Tercero;
}

export class GetTerceroByIdResponse {
    public mensaje: string;
    public error: boolean;
    public tercero:Tercero;
}

export class GetTerceroByFiltroResponse {
    public mensaje: string;
    public terceros:Tercero[];
}

export class CrearTerceroServiceRequest {
    public Tercero: Tercero;
}
export class CrearTerceroServiceResponse {
    public mensaje: string;
    public error: boolean;
    public tercero:Tercero;
}

export class EditarTerceroServiceRequest {
    public Tercero: Tercero;
}
export class EditarTerceroServiceResponse {
    public mensaje: string;
    public error: boolean;
    public tercero:Tercero;
}

export class EliminarTerceroServiceResponse {
    public mensaje: string;
    public error: boolean;
}

export class TerceroDatosFormularioResponse {
    public departamentos:Departamento[];
    public municipio:Municipio[];
}

export class TipoTercero {
    public id: string;
    public name: string;
}

export interface OrdenTercero {
    id: string;
    name: string;
}